import { render, staticRenderFns } from "./EggCollection.vue?vue&type=template&id=1d0a2e5e"
import script from "./EggCollection.vue?vue&type=script&lang=js"
export * from "./EggCollection.vue?vue&type=script&lang=js"
import style0 from "./EggCollection.vue?vue&type=style&index=0&id=1d0a2e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports